import {PhoneNumber} from './PhoneNumber';

/**
 * @deprecated
 */
export type ContactPhoneNumber = {
  uuid: string;
  phoneNumber: PhoneNumber | null;
  note: string | null;
  default: boolean | null;
};
